import { RpcEngine } from '../core/rpc.js'
import { METHODS } from '../core/events.js'
import type { SpeakOptions, BgmOptions, BgmStopOptions, SfxOptions } from '../types/index.js'

class BgmController {
  constructor(private rpc: RpcEngine) {}
  play(url: string, options?: BgmOptions):    Promise<void> { return this.rpc.call(METHODS.MEDIA_BGM_PLAY, [url, options]) }
  stop(options?: BgmStopOptions):             Promise<void> { return this.rpc.call(METHODS.MEDIA_BGM_STOP, [options]) }
  pause():                                    Promise<void> { return this.rpc.call(METHODS.MEDIA_BGM_PAUSE) }
  resume():                                   Promise<void> { return this.rpc.call(METHODS.MEDIA_BGM_RESUME) }
  setVolume(volume: number):                  Promise<void> { return this.rpc.post(METHODS.MEDIA_BGM_VOLUME, [volume]) }
}

class SfxController {
  constructor(private rpc: RpcEngine) {}
  play(url: string, options?: SfxOptions): Promise<void> { return this.rpc.call(METHODS.MEDIA_SFX_PLAY, [url, options]) }
  preload(urls: string[]):                 Promise<void> { return this.rpc.post(METHODS.MEDIA_SFX_PRELOAD, [urls]) }
}

export class MediaModule {
  readonly bgm: BgmController
  readonly sfx: SfxController

  constructor(private rpc: RpcEngine) {
    this.bgm = new BgmController(rpc)
    this.sfx = new SfxController(rpc)
  }

  speak(text: string, options?: SpeakOptions): Promise<void> { return this.rpc.call(METHODS.MEDIA_SPEAK, [text, options]) }
  stopSpeak():                                 Promise<void> { return this.rpc.post(METHODS.MEDIA_SPEAK_STOP) }
}
